import { debounce } from 'lodash';
import smoothscroll from 'smoothscroll-polyfill';

class BrixModuleSelectedEvents {
  static init(...parameters) {
    return new BrixModuleSelectedEvents(...parameters);
  }

  constructor(selector) {
    this.selector = selector;

    this.scrollWrapper = this.selector.querySelector('.scroll-wrapper');

    if (this.scrollWrapper) {
      this.scrollWrapper = this.selector.querySelector('.scroll-wrapper');
      this.occasionsWrapper = this.selector.querySelector('.occasions');
      this.firstOccasion = this.occasionsWrapper.querySelector('.occasion');
      this.earlierDatesButton = this.selector.querySelector('.scroll-button.-earlier');
      this.laterDatesButton = this.selector.querySelector('.scroll-button.-later');

      smoothscroll.polyfill();
      this.toggleButtonVisibility();

      if (this.earlierDatesButton) {
        this.earlierDatesButton.addEventListener('click', () => {
          const occasionWidth = this.firstOccasion.offsetWidth;

          this.occasionsWrapper.scrollBy({
            top: 0,
            left: occasionWidth * -1,
            behavior: 'smooth',
          });
        });
      }

      if (this.earlierDatesButton) {
        this.laterDatesButton.addEventListener('click', () => {
          const occasionWidth = this.firstOccasion.offsetWidth;

          this.occasionsWrapper.scrollBy({
            top: 0,
            left: occasionWidth,
            behavior: 'smooth',
          });
        });
      }

      this.occasionsWrapper.addEventListener('scroll', debounce(() => {
        this.toggleButtonVisibility();
      }));
    }
  }

  onDateWrapperScroll() {
    this.toggleButtonVisibility();
  }

  toggleButtonVisibility() {
    if (!this.laterDatesButton.classList.contains('-show')) {
      this.laterDatesButton.classList.add('-show');
    }

    if (!this.earlierDatesButton.classList.contains('-show')) {
      this.earlierDatesButton.classList.add('-show');
    }

    if (this.occasionsWrapper.scrollLeft === 0) {
      if (this.earlierDatesButton.classList.contains('-show')) {
        this.earlierDatesButton.classList.remove('-show');
      }
    }

    if (this.occasionsWrapper.scrollWidth - this.occasionsWrapper.offsetWidth
      === this.occasionsWrapper.scrollLeft
    ) {
      if (this.laterDatesButton.classList.contains('-show')) {
        this.laterDatesButton.classList.remove('-show');
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-selected-events', BrixModuleSelectedEvents.init);
}
